import { DatalayersMap } from "@omnia/shared/layers/datalayersMap"
import { IFieldsMapContainerContext, IFieldsMapContainerOptions } from "@omnia/types"

export class NutritionMap extends DatalayersMap {

    constructor(ctxt: IFieldsMapContainerContext, options?: IFieldsMapContainerOptions) {
        super(ctxt, options)
    }

}
